// extracted by mini-css-extract-plugin
export default {"imageWrapper":"mS-z","hovered":"nS-z","hoverImage":"oS-z","mainImage":"pS-z","imageNoBackground":"qS-z","fullSizeImage":"rS-z"};